import { requestWorkspaceMode } from "@/lib/workspaceModeNavigation";

const PENDING_OPS_DEAL_KEY = "bb-pending-ops-paperwork-deal";

/** Navigate to Operations paperwork and select this deal when the panel mounts. */
export function openOpsPaperworkDeal(dealId: string): void {
  if (typeof window === "undefined") return;
  const id = dealId.trim();
  if (!/^[0-9a-f-]{36}$/i.test(id)) return;
  try {
    sessionStorage.setItem(PENDING_OPS_DEAL_KEY, id);
  } catch {
    // ignore
  }
  requestWorkspaceMode({ mode: "operations" });
}

export function consumePendingOpsPaperworkDealId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const v = sessionStorage.getItem(PENDING_OPS_DEAL_KEY);
    sessionStorage.removeItem(PENDING_OPS_DEAL_KEY);
    if (v && /^[0-9a-f-]{36}$/i.test(v)) return v;
  } catch {
    // ignore
  }
  return null;
}
